import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
import { CourseHService } from '../courseH.service';

@Component({
  selector: 'batchersH',
  templateUrl: 'batchersH.component.html',
  styleUrls: ['batchersH.component.scss']
})

export class AddBatchersHComponent implements OnInit {
  public schoolId: any;
  display = "none"
  public rolesList: any;
  public info:boolean=false;


  public HigherEdchildcourse: any;
  public selectedCourse: string = '';
  public HigherEdchildbatch: any;
  public selectedBatch: string = '';

  public selectedCoursePost: string = '';
  public batchname: string = '';
  public selecteddateT: string = '2023-05-11T07:37:08.926Z';
  public selecteddate: string = '';
  public studentcount: string = '';
  public status: string = '';



  constructor( private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
    private courseHService: CourseHService) {
    this.schoolId = this.localStorage.retrieve('schoolid');
    
  }
  ngOnInit() {
    this.GetCourseList();
  }

   formatDate(date) {
    var yyyy = date.getUTCFullYear();
    var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so we need to add 1
    var dd = String(date.getUTCDate()).padStart(2, '0');
    var hh = String(date.getUTCHours()).padStart(2, '0');
    var min = String(date.getUTCMinutes()).padStart(2, '0');
    var sec = String(date.getUTCSeconds()).padStart(2, '0');
    var sss = String(date.getUTCMilliseconds()).padStart(3, '0');
    
    return `${yyyy}-${mm}-${dd}T${hh}:${min}:${sec}.${sss}Z`;
}

//------------------------------------------------------------------------------------------------

  private GetCourseList(){
    this.courseHService.getHigherEdChildCourseList().finally(() => { }).subscribe(
      response => {
        this.HigherEdchildcourse = response['items'];
        try {
          this.selectedCourse =  this.HigherEdchildcourse[0].CourseId;
          this.getHigherEdChildBatch()
        } catch (error) {
          
        }
        console.log('CourseList',this.HigherEdchildcourse)
        console.log('selectedcours',this.selectedCourse)
      },
      error => {
        console.error(error);
      });
  };

  changecourse() {
   console.log("courseT",this.selectedCourse)
   this.getHigherEdChildBatch()
  };

  // -------------------------------------------------------------------------------------------

  private getHigherEdChildBatch(){
    this.courseHService.getHigherEdChildBatchList(this.selectedCourse).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildbatch = response['Value'];
        console.log('HigherEdchildbatch',this.HigherEdchildbatch)
      },
      error => {
        this.HigherEdchildbatch = [];
        console.error(error);
      });
  };

  changebatch() {
   console.log("batch",this.selectedBatch)
  };
//------------------------------------------------------------------------------------------------

postbatchModeules() {
  var payload = {
    Batch: this.batchname,
    CourseId: this.selectedCoursePost,
    Batch_Created_Date: this.formatDate(this.selecteddate),
    StudentCount: this.studentcount,
    Status: this.status,
  };
  
  console.log("postbatchModeules",payload);

  this.courseHService
    .postHigherEdChildBatchList(payload)
    .finally(() => {})
    .subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: "Semester Batch Added Successfully",
        });
        this.display = "none";
        this.getHigherEdChildBatch();
    
        console.log(response);
      },
      (error) => {}
    );
}

DateModal() {
  console.log("Date",this.selecteddate)
 };

//-------------------------------------------------------------------------------------------------

  roleinfo(){
    this.info=true;
   }
  
 addSem() {
   this.display= "block"
   // this.display = true;
 }
 onCloseHandled() {
   this.display= "none";
 }
 
 

}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/batchers/batchersH.component.ts